/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Preset_Load_TitleInputs */

const en_video_export_export_preset_load_title = /** @type {(inputs: Video_Export_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load Video Export Preset`)
};

const fr_video_export_export_preset_load_title = /** @type {(inputs: Video_Export_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger un prereglage d'exportation video`)
};

const de_video_export_export_preset_load_title = /** @type {(inputs: Video_Export_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video-Export-Voreinstellung laden`)
};

const it_video_export_export_preset_load_title = /** @type {(inputs: Video_Export_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica preimpostazione esportazione video`)
};

const ru_video_export_export_preset_load_title = /** @type {(inputs: Video_Export_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузить предустановку экспорта видео`)
};

const es_video_export_export_preset_load_title = /** @type {(inputs: Video_Export_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar ajuste preestablecido de exportación de vídeo`)
};

const zh_cn2_video_export_export_preset_load_title = /** @type {(inputs: Video_Export_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载视频导出预设`)
};

const ja_video_export_export_preset_load_title = /** @type {(inputs: Video_Export_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオエクスポートプリセットを読み込む`)
};

const hi_video_export_export_preset_load_title = /** @type {(inputs: Video_Export_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात प्रीसेट लोड करें`)
};

const pt_pt2_video_export_export_preset_load_title = /** @type {(inputs: Video_Export_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar predefinição de exportação de vídeo`)
};

/**
* | output |
* | --- |
* | "Load Video Export Preset" |
*
* @param {Video_Export_Export_Preset_Load_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_load_title = /** @type {((inputs?: Video_Export_Export_Preset_Load_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_Load_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_export_preset_load_title(inputs)
	if (locale === "de") return de_video_export_export_preset_load_title(inputs)
	if (locale === "it") return it_video_export_export_preset_load_title(inputs)
	if (locale === "ru") return ru_video_export_export_preset_load_title(inputs)
	if (locale === "es") return es_video_export_export_preset_load_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_export_preset_load_title(inputs)
	if (locale === "ja") return ja_video_export_export_preset_load_title(inputs)
	if (locale === "hi") return hi_video_export_export_preset_load_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_export_preset_load_title(inputs)
	return en_video_export_export_preset_load_title(inputs)
});